// extracted by mini-css-extract-plugin
export default {"loadedContentContainer":"Loader_loadedContentContainer__H8Unz","loaderContainer":"Loader_loaderContainer__OZWYk","loaderRect":"Loader_loaderRect__YnjgC","draw":"Loader_draw__NED9w"};